import React, { useContext, useState } from "react";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Tabs,
} from "antd";
import { RedoOutlined } from "@ant-design/icons";
import "../../../../CapsitechAccountsComponents/Common/Acc_Common.css";
import "../../../Pages/Parties/Party.css";
import "../../../Services/SettingService";
import { Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useClient } from "../../../Context/ClientContext";
import {
  InvoiceTemplates,
  ITemplateSettings,
  Logo_Position,
  SettingsSections,
  TnC_Position,
} from "../../../Services/SettingService";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../../Services/LedgerService";

export const fontSizeOptions = [
  { label: "9pt", value: 9 },
  { label: "10pt", value: 10 },
  { label: "11pt", value: 11 },
  { label: "12pt", value: 12 },
];

export const fontNameOptions = [
  { value: "Arial", label: "Arial" },
  { value: "Roboto", label: "Roboto" },
  { value: "Ubuntu", label: "Ubuntu" },
  { value: "Sans-Serif", label: "Sans-Serif" },
];

export const voucherTitlefontSizeOptions = [
  { label: "12pt", value: 12 },
  { label: "14pt", value: 14 },
  { label: "16pt", value: 16 },
  { label: "18pt", value: 18 },
  // { label: "20pt", value: 20 },
];

export const titleFontSize = [
  { label: "18pt", value: 18 },
  { label: "20pt", value: 20 },
  { label: "22pt", value: 22 },
  { label: "24pt", value: 24 },
];

// export const taxSubtotals: any = [
//   { label: "Tax rates", value: 0 },
//   { label: "Tax rates over 0%", value: 1 },
//   { label: "A single tax subtotal", value: 2 },
// ];

const EditInvoiceTemplate: React.FC = () => {
  const { Text } = Typography;
  const { openNotification } = useContext(notificationContext);
  const navigate = useNavigate();
  let { type }: any = useParams();
  const { currentClient, companySettings, updateCompanySettings } = useClient();
  const [showBankDetail, setShowBankDetail] = React.useState<boolean>(false);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const [bankLedgers, setBankLedgers] = React.useState<any>([]);
  const [trigger, setTrigger] = React.useState<boolean>(false);
  const typeAsInt = parseInt(type);
  console.log("type", typeAsInt);

  const defaultAddressOption = currentClient?.addresses;
  console.log("defaultAddressOption", defaultAddressOption);

  // const { type } = useParams();
  const [form] = Form.useForm();
  //Reset Values
  const resetValues: ITemplateSettings = {
    type: InvoiceTemplates.Template1,
    // name: "Basic Template",
    generalTS: {
      paperSize: "A4",
      measureIn: "mm",
      topMargin: "15mm",
      bottomMargin: "15mm",
      leftMargin: "25mm",
      rightMargin: "15mm",
      // addressPadding: 0,
      // taxSubtotals: 0,
      // headingFontSize: 11,
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    companyTS: {
      showLogo: false,
      logoAlign: Logo_Position.LeftToCompanyName,
      showCompanyAddress: true,
      defaultAddress: null,
      showGSTIN: true,
      showPan: true,
      showEmail: true,
      showPhone: true,
      showWebsite: true,
      companyNameFont: {
        fontFamily: "Arial",
        fontSize: 18,
      },
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    voucherTitleTS: {
      fontFamily: "Arial",
      fontSize: 16,
    },
    buyerShipperTS: {
      fontFamily: "Arial",
      fontSize: 10,
    },
    voucherDetailTS: {
      showEWayBillNo: false,
      showEInvoiceNo: false,
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    itemDetailTS: {
      // showItemCode: true,
      showUnit: true,
      showHSN: true,
      font: {
        fontFamily: "Arial",
        fontSize: 9,
      },
    },
    taxSummaryTS: {
      showTaxableValue: true,
      font: {
        fontFamily: "Arial",
        fontSize: 9,
      },
    },
    bankDetailTS: {
      showBankDetail: false,
      showQRorUPI: false,
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    balanceDetailTS: {
      showBalanceStatus: false,
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    dispatchDetailTS: {
      showDispatchDetail: false,
      font: {
        fontFamily: "Arial",
        fontSize: 9,
      },
    },
    signDetailTS: {
      headingFont: {
        fontFamily: "Arial",
        fontSize: 12,
      },
      font: {
        fontFamily: "Arial",
        fontSize: 10,
      },
    },
    termsndConditionTS: {
      tnCPosition: TnC_Position.TopRight,
      font: {
        fontFamily: "Arial",
        fontSize: 9,
      },
    },
    // otherTS: {
    //   showTaxColumn: true,
    //   taxInclusive: true,
    //   contactDetails: false,
    //   showUnitPriceAndQty: true,
    //   showPaymentAdviceCutAway: true,
    //   showRegisteredAddress: true,
    //   hideDisc: false,
    //   showContactAcNo: true,
    //   // showColumnHeading: true,
    //   psCreditCard: {
    //     name: "",
    //     id: 0,
    //   },
    //   psPayPal: {
    //     name: "",
    //     id: 0,
    //   },
    //   psBankPayments: {
    //     name: "",
    //     id: 0,
    //   },
    //   showTaxNo: false,
    // },
    showHeaderContinuation: false,
  };
  const [isChanged, setIsChanged] = useState<ITemplateSettings>(resetValues);

  React.useEffect(() => {
    if (typeAsInt || typeAsInt === 0) {
      const allTempleteData = companySettings?.setting;
      const templeteData = allTempleteData?.templateSettings?.find(
        (x) => x?.type === typeAsInt
      );
      // debugger;
      console.log("templeteData", templeteData);
      if (templeteData) {
        setShowBankDetail(templeteData?.bankDetailTS?.showBankDetail);
        form.setFieldsValue({
          ...templeteData,
          // ...templeteData?.generalTS,
          // ...templeteData?.companyTS,
          // ...templeteData?.voucherTitleTS,
          // ...templeteData?.buyerShipperTS,
          // ...templeteData?.voucherDetailTS,
          // ...templeteData?.itemDetailTS,
          // ...templeteData?.taxableValueTS,
          // ...templeteData?.bankDetailTS,
          // ...templeteData?.dispatchDetailTS,
          // ...templeteData?.signDetailTS,
          // ...templeteData?.voucherTitleTS,

          // fontFamily: templeteData?.generalTS?.font?.fontFamily,
          // fontSize: templeteData?.generalTS?.font?.fontSize,
        });
        setIsChanged(templeteData);
      } else {
        console.error("Not found templeteData");
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySettings, trigger]);

  React.useEffect(() => {
    if (showBankDetail) {
      LedgerService.getLedgersByGroupName(
        currentClient?.id!,
        SearchLedgerByGroupsTypes.BankOnly
      ).then((res: any) => {
        setBankLedgers(res);
      });
    } else {
      setBankLedgers([]);
    }
  }, [showBankDetail]);

  // console.log("trr", trigger);

  const onsubmit = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        setSaveButtonLoading(true);
        const data = { ...isChanged };
        console.log("formData", data);

        const postData: any = {
          templateSettings: companySettings?.setting?.templateSettings?.map(
            (t) => {
              if (t.type === ((typeAsInt ?? 0) as InvoiceTemplates)) {
                return {
                  ...t,
                  ...data,
                };
              }
              return {
                ...t,
                // GeneralTS,
              };
            }
          ),
          defaultTemplate: typeAsInt ?? 0,
        };
        console.log("postData", postData);

        if (postData) {
          await updateCompanySettings!(
            SettingsSections.Template,
            {
              ...companySettings,
              setting: {
                ...companySettings?.setting!,
                templateSettings: postData?.templateSettings,
                defaultTemplate: postData?.defaultTemplate,
              },
            },
            postData
          ).then((result: any) => {
            if (result?.status) {
              openNotification("success", "Setting updated successfully.");
              setTrigger((x: boolean) => !x);
              setSaveButtonLoading(false);
            } else {
              setSaveButtonLoading(false);
              openNotification("error", "There is some error.");
            }
          });
        }
        // updateCompanySettings!(
        //   SettingsSections.Template,
        //   {
        //     ...companySettings,
        //     setting: {
        //       ...companySettings?.setting!,
        //       template: data?.dueOn,
        //     },
        //   },
        //   data
        // );
      })
      .catch((error: any) => {
        console.log(error, "error-------");
      });
  };

  // const formBaiscLayout = () => {
  //   return (
  //     <Form
  //       form={form}
  //       name="templateform"
  //       requiredMark={false}
  //       colon={false}
  //       labelAlign="left"
  //       size="small"
  //       labelCol={{ span: 11 }}
  //       wrapperCol={{ span: 16 }}
  //       autoComplete="off"
  //     >
  //       <Form.Item
  //         label="Font"
  //         name={["generalTS", "font", "fontFamily"]}
  //         className="inputBoxMb8"
  //       >
  //         <Select
  //           style={{ width: "147px" }}
  //           // defaultValue={isChanged?.generalTS?.font?.fontFamily}
  //           options={[
  //             { value: "Arial", label: "Arial" },
  //             { value: "Calibri", label: "Calibri" },
  //             { value: "Cambria", label: "Cambria" },
  //             { value: "Georgia", label: "Georgia" },
  //             { value: "Myriad", label: "Myriad-Pro" },
  //             { value: "Tahoma", label: "Tahoma" },
  //           ]}
  //           onChange={(e: any) => {
  //             setIsChanged({
  //               ...isChanged,
  //               generalTS: {
  //                 ...isChanged?.generalTS,
  //                 font: {
  //                   ...isChanged?.generalTS?.font,
  //                   fontFamily: e,
  //                 },
  //               },
  //             });
  //             //console.log(isChanged.font);
  //           }}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         label="Font size"
  //         name={["generalTS", "font", "fontSize"]}
  //         className="inputBoxMb8"
  //       >
  //         <Select
  //           style={{ width: "147px" }}
  //           options={fontSizeOptions}
  //           onChange={(e: any) => {
  //             setIsChanged({
  //               ...isChanged,
  //               generalTS: {
  //                 ...isChanged?.generalTS,
  //                 font: {
  //                   ...isChanged?.generalTS?.font,
  //                   fontSize: e,
  //                 },
  //               },
  //             });
  //           }}
  //         />
  //       </Form.Item>
  //     </Form>
  //   );
  // };

  const [formData, setFormData] = useState({});

  const handleValuesChange = (changedValues: any, allValues: any) => {
    setFormData(allValues);
  };

  const handleTabChange = (key: string) => {
    form.setFieldsValue(formData);
  };

  console.log("isChanged", isChanged);

  return (
    <>
      <div style={{ backgroundColor: "#f7f8faff" }}>
        <Row>
          <Col lg={10} md={24}>
            <Card
              style={{
                border: "1.5px solid #eef2fe",
                height: "96%",
                overflowY: "hidden",
              }}
              // className="templatesec"
            >
              <Row
                style={{
                  fontWeight: 500,
                  color: "#0b308e",
                  alignItems: "center",
                }}
                justify={"space-between"}
              >
                <Col
                  style={{
                    // borderBottom: "1px solid rgb(210, 208, 206)",
                    padding: "10px 0",
                  }}
                >
                  <span>Template Settings</span>
                </Col>
                <Col>
                  <Button
                    type="primary"
                    onClick={() => {
                      form.setFieldsValue(resetValues);
                      setIsChanged(resetValues);
                    }}
                    // onClick={() => setTrigger((prev) => !prev)}
                  >
                    <RedoOutlined style={{ fontSize: "16px" }} />
                    Reset
                  </Button>
                </Col>
              </Row>
              <Row>
                <Form
                  form={form}
                  name="templateform"
                  requiredMark={false}
                  colon={false}
                  labelAlign="left"
                  size="small"
                  labelCol={{ span: 11 }}
                  wrapperCol={{ span: 16 }}
                  autoComplete="off"
                  // onValuesChange={handleValuesChange}
                  initialValues={isChanged}
                >
                  <Tabs
                    // onChange={handleTabChange}
                    defaultActiveKey="1"
                    tabPosition="left"
                    className="ca-tab-invoicepdftab"
                    items={[
                      {
                        label: "General Settings",
                        key: "1",
                        children: (
                          <>
                            <Form.Item
                              label="Name"
                              name="name"
                              className="inputBoxMb8"
                            >
                              <Input style={{ width: "147px" }} disabled />
                            </Form.Item>
                            <Form.Item
                              label="Paper Size"
                              name={["generalTS", "paperSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={[{ value: "A4", label: "A4" }]}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Measure in"
                              name={["generalTS", "measureIn"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={[
                                  {
                                    value: "mm",
                                    label: "mm",
                                  },
                                ]}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Top margin"
                              // initialValue={0}
                              name={["generalTS", "topMargin"]}
                              className="inputBoxMb8"
                            >
                              <InputNumber
                                precision={0}
                                min={0}
                                max={290}
                                style={{ width: "147px" }}
                                onChange={(e: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      topMargin: e?.target?.value,
                                    },
                                    // topMargin: e.target.value,
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Bottom margin"
                              // initialValue={0}
                              name={["generalTS", "bottomMargin"]}
                              className="inputBoxMb8"
                            >
                              <InputNumber
                                precision={0}
                                min={0}
                                max={290}
                                style={{ width: "147px" }}
                                onChange={(e: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      bottomMargin: e?.target?.value,
                                    },
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Left margin"
                              // initialValue={0}
                              name={["generalTS", "leftMargin"]}
                              className="inputBoxMb8"
                            >
                              <InputNumber
                                precision={0}
                                min={0}
                                max={200}
                                style={{ width: "147px" }}
                                onChange={(e: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      leftMargin: e?.target?.value,
                                    },
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              // initialValue={0}
                              label="Right margin"
                              name={["generalTS", "rightMargin"]}
                              className="inputBoxMb8"
                            >
                              <InputNumber
                                precision={0}
                                min={0}
                                max={200}
                                style={{ width: "147px" }}
                                onChange={(e: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      rightMargin: e?.target?.value,
                                    },
                                  });
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font"
                              name={["generalTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      font: {
                                        ...isChanged?.generalTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    generalTS: {
                                      ...prev?.generalTS,
                                      font: {
                                        ...prev?.generalTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["generalTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    generalTS: {
                                      ...isChanged?.generalTS,
                                      font: {
                                        ...isChanged?.generalTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    generalTS: {
                                      ...prev?.generalTS,
                                      font: {
                                        ...prev?.generalTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Company Details",
                        key: "2",
                        children: (
                          <>
                            <Form.Item
                              label="Title Font"
                              name={[
                                "companyTS",
                                "companyNameFont",
                                "fontFamily",
                              ]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    companyTS: {
                                      ...isChanged?.companyTS,
                                      companyNameFont: {
                                        ...isChanged?.companyTS
                                          ?.companyNameFont,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    companyTS: {
                                      ...prev?.companyTS,
                                      companyNameFont: {
                                        ...prev?.companyTS?.companyNameFont,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Title Font size"
                              name={[
                                "companyTS",
                                "companyNameFont",
                                "fontSize",
                              ]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={titleFontSize}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    companyTS: {
                                      ...isChanged?.companyTS,
                                      companyNameFont: {
                                        ...isChanged?.companyTS
                                          ?.companyNameFont,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    companyTS: {
                                      ...prev?.companyTS,
                                      companyNameFont: {
                                        ...prev?.companyTS?.companyNameFont,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              label="Show Logo"
                              className="inputBoxMb8"
                              name={["companyTS", "showLogo"]}
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={isChanged?.companyTS?.showLogo}
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showLogo: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showLogo: e?.target?.checked,
                                        logoAlign:
                                          Logo_Position.LeftToCompanyName,
                                      },
                                    });
                                  }
                                  // console.log(isChanged, "logoimg");
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Logo alignment"
                              className="inputBoxMb8"
                              name={["companyTS", "logoAlign"]}
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={[
                                  {
                                    value: Logo_Position.LeftToCompanyName,
                                    label: "Left to Company Name",
                                  },
                                  {
                                    value: Logo_Position.AboveCompanyName,
                                    label: "Above the Company Name",
                                  },
                                ]}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show Address"
                              name={["companyTS", "showCompanyAddress"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.companyTS?.showCompanyAddress
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showCompanyAddress: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showCompanyAddress: false,
                                      },
                                      // showCompanyAddress: false,
                                    });
                                  }
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              label="Default Address"
                              name={["companyTS", "defaultAddress"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                allowClear
                                style={{ width: "147px" }}
                                placeholder="Select address"
                                options={defaultAddressOption?.map(
                                  (x: any) => ({
                                    value: x?.addressName,
                                    label: x?.addressName,
                                    // title: x?.type,
                                  })
                                )}
                                onChange={(value) => {
                                  // console.log("address", value);
                                  form.setFieldsValue({
                                    companyTS: {
                                      ...isChanged?.companyTS,
                                      defaultAddress: value,
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    companyTS: {
                                      ...prev?.companyTS,
                                      defaultAddress: value,
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              label="Show GSTIN"
                              // name="showGSTIN"
                              name={["companyTS", "showGSTIN"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                // defaultChecked={isChanged?.companyTS?.showGSTIN}
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showGSTIN: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showGSTIN: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show PAN"
                              name={["companyTS", "showPan"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={isChanged?.companyTS?.showPan}
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showPan: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showPan: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show Email"
                              name={["companyTS", "showEmail"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={isChanged?.companyTS?.showEmail}
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showEmail: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showEmail: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show Mobile No."
                              name={["companyTS", "showPhone"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={isChanged?.companyTS?.showPhone}
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showPhone: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showPhone: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show Website"
                              name={["companyTS", "showWebsite"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.companyTS?.showWebsite
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showWebsite: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      companyTS: {
                                        ...isChanged?.companyTS,
                                        showWebsite: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font"
                              name={["companyTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    companyTS: {
                                      ...isChanged?.companyTS,
                                      font: {
                                        ...isChanged?.companyTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    companyTS: {
                                      ...prev?.companyTS,
                                      font: {
                                        ...prev?.companyTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["companyTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    companyTS: {
                                      ...isChanged?.companyTS,
                                      font: {
                                        ...isChanged?.companyTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    companyTS: {
                                      ...prev?.companyTS,
                                      font: {
                                        ...prev?.companyTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Voucher Title",
                        key: "3",
                        children: (
                          <>
                            <Form.Item
                              label="Font"
                              name={["voucherTitleTS", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value: any) => {
                                  form.setFieldsValue({
                                    voucherTitleTS: {
                                      ...isChanged?.voucherTitleTS,
                                      fontFamily: value,
                                    },
                                  });

                                  setIsChanged((prev: any) => ({
                                    ...prev,
                                    voucherTitleTS: {
                                      ...prev?.voucherTitleTS,
                                      fontFamily: value,
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["voucherTitleTS", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={voucherTitlefontSizeOptions}
                                onChange={(value: string) => {
                                  form.setFieldsValue({
                                    voucherTitleTS: {
                                      ...isChanged?.voucherTitleTS,
                                      fontSize: value,
                                    },
                                  });

                                  setIsChanged((prev: any) => ({
                                    ...prev,
                                    voucherTitleTS: {
                                      ...prev?.voucherTitleTS,
                                      fontSize: value,
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Buyer & Shipper Details",
                        key: "4",
                        children: (
                          <>
                            <Form.Item
                              label="Font"
                              name={["buyerShipperTS", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  // form.setFieldsValue({
                                  //   buyerShipperTS: {
                                  //     ...isChanged?.buyerShipperTS,
                                  //     fontFamily: value,
                                  //   },
                                  // });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    buyerShipperTS: {
                                      ...prev?.buyerShipperTS,
                                      fontFamily: value,
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["buyerShipperTS", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  // form.setFieldsValue({
                                  //   buyerShipperTS: {
                                  //     ...isChanged?.buyerShipperTS,
                                  //     fontSize: value,
                                  //   },
                                  // });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    buyerShipperTS: {
                                      ...prev?.buyerShipperTS,
                                      fontSize: value,
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Voucher Details",
                        key: "5",
                        children: (
                          <>
                            <Form.Item
                              label="Show EWay Bill Detail"
                              labelCol={{ span: 17 }}
                              name={["voucherDetailTS", "showEWayBillNo"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.voucherDetailTS?.showEWayBillNo
                                }
                                onChange={(e: any) => {
                                  if (e.target.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      voucherDetailTS: {
                                        ...isChanged?.voucherDetailTS,
                                        showEWayBillNo: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      voucherDetailTS: {
                                        ...isChanged?.voucherDetailTS,
                                        showEWayBillNo: e?.target?.checked,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show E-Invoice Detail"
                              labelCol={{ span: 17 }}
                              name={["voucherDetailTS", "showEInvoiceNo"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.voucherDetailTS?.showEInvoiceNo
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      voucherDetailTS: {
                                        ...isChanged?.voucherDetailTS,
                                        showEInvoiceNo: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      voucherDetailTS: {
                                        ...isChanged?.voucherDetailTS,
                                        showEInvoiceNo: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font"
                              labelCol={{ span: 17 }}
                              name={["voucherDetailTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    voucherDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      font: {
                                        ...isChanged?.voucherDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    voucherDetailTS: {
                                      ...prev?.voucherDetailTS,
                                      font: {
                                        ...prev?.voucherDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              labelCol={{ span: 17 }}
                              name={["voucherDetailTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    voucherDetailTS: {
                                      ...isChanged?.voucherDetailTS,
                                      font: {
                                        ...isChanged?.voucherDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    voucherDetailTS: {
                                      ...prev?.voucherDetailTS,
                                      font: {
                                        ...prev?.voucherDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Item Details",
                        key: "6",
                        children: (
                          <>
                            <Form.Item
                              label="Show Unit"
                              labelCol={{ span: 14 }}
                              name={["itemDetailTS", "showUnit"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.itemDetailTS?.showUnit
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      itemDetailTS: {
                                        ...isChanged?.itemDetailTS,
                                        showUnit: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      itemDetailTS: {
                                        ...isChanged?.itemDetailTS,
                                        showUnit: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Show HSC/SAC"
                              labelCol={{ span: 14 }}
                              name={["itemDetailTS", "showHSN"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.itemDetailTS?.showHSN
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      itemDetailTS: {
                                        ...isChanged?.itemDetailTS,
                                        showHSN: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      itemDetailTS: {
                                        ...isChanged?.itemDetailTS,
                                        showHSN: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font"
                              labelCol={{ span: 14 }}
                              name={["itemDetailTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    itemDetailTS: {
                                      ...isChanged?.itemDetailTS,
                                      font: {
                                        ...isChanged?.itemDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    itemDetailTS: {
                                      ...prev?.itemDetailTS,
                                      font: {
                                        ...prev?.itemDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              labelCol={{ span: 14 }}
                              name={["itemDetailTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    itemDetailTS: {
                                      ...isChanged?.itemDetailTS,
                                      font: {
                                        ...isChanged?.itemDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    itemDetailTS: {
                                      ...prev?.itemDetailTS,
                                      font: {
                                        ...prev?.itemDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Tax Summary",
                        key: "7",
                        children: (
                          <>
                            <Form.Item
                              label="Show Tax Summary"
                              labelCol={{ span: 15 }}
                              name={["taxSummaryTS", "showTaxableValue"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.taxSummaryTS?.showTaxableValue
                                }
                                onChange={(e: any) => {
                                  if (e.target.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      taxSummaryTS: {
                                        ...isChanged?.taxSummaryTS,
                                        showTaxableValue: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      taxSummaryTS: {
                                        ...isChanged?.taxSummaryTS,
                                        showTaxableValue: false,
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              label="Font"
                              labelCol={{ span: 15 }}
                              name={["taxSummaryTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    taxSummaryTS: {
                                      ...isChanged?.taxSummaryTS,
                                      font: {
                                        ...isChanged?.taxSummaryTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    taxSummaryTS: {
                                      ...prev?.taxSummaryTS,
                                      font: {
                                        ...prev?.taxSummaryTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              labelCol={{ span: 15 }}
                              name={["taxSummaryTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    taxSummaryTS: {
                                      ...isChanged?.taxSummaryTS,
                                      font: {
                                        ...isChanged?.taxSummaryTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    taxSummaryTS: {
                                      ...prev?.taxSummaryTS,
                                      font: {
                                        ...prev?.taxSummaryTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Bank Details",
                        key: "8",
                        children: (
                          <>
                            <Form.Item
                              label="Bank Details"
                              labelCol={{ span: 11 }}
                              name={["bankDetailTS", "showBankDetail"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                style={{ width: "147px" }}
                                defaultChecked={
                                  isChanged?.bankDetailTS?.showBankDetail
                                }
                                onChange={(e: any) => {
                                  if (e?.target?.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      bankDetailTS: {
                                        ...isChanged?.bankDetailTS,
                                        showBankDetail: e?.target?.checked,
                                      },
                                    });
                                    form.setFieldValue(
                                      ["bankDetailTS", "defaultBankLedgerId"],
                                      null
                                    );
                                    form.setFieldValue(
                                      ["bankDetailTS", "showQRorUPI"],
                                      false
                                    );
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      bankDetailTS: {
                                        ...isChanged?.bankDetailTS,
                                        showBankDetail: false,
                                      },
                                    });
                                  }
                                  setShowBankDetail(e?.target?.checked);
                                  console.log(
                                    isChanged?.bankDetailTS?.showBankDetail,
                                    "ok"
                                  );
                                }}
                              />
                            </Form.Item>
                            {showBankDetail && (
                              <>
                                {" "}
                                <Form.Item
                                  label="Bank Ledger"
                                  labelCol={{ span: 11 }}
                                  name={["bankDetailTS", "defaultBankLedgerId"]}
                                  className="inputBoxMb8"
                                >
                                  <Select
                                    placeholder="Select Bank"
                                    style={{ width: "147px" }}
                                    options={bankLedgers?.map((value: any) => ({
                                      value: value?.id,
                                      label: value?.ledgerName.concat(
                                        value?.aliasName
                                          ? `${" (" + value?.aliasName + ")"}`
                                          : ""
                                      ),
                                    }))}
                                    onChange={(value) => {
                                      form.setFieldsValue({
                                        bankDetailTS: {
                                          ...isChanged?.bankDetailTS,
                                          defaultBankLedgerId: value,
                                        },
                                      });

                                      setIsChanged((prev) => ({
                                        ...prev,
                                        bankDetailTS: {
                                          ...prev?.bankDetailTS,
                                          defaultBankLedgerId: value,
                                        },
                                      }));
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="QR or UPI"
                                  labelCol={{ span: 11 }}
                                  name={["bankDetailTS", "showQRorUPI"]}
                                  className="inputBoxMb8"
                                  valuePropName="checked"
                                >
                                  <Checkbox
                                    style={{ width: "147px" }}
                                    defaultChecked={
                                      isChanged?.bankDetailTS?.showBankDetail
                                    }
                                    onChange={(e: any) => {
                                      if (e?.target?.checked) {
                                        setIsChanged({
                                          ...isChanged,
                                          bankDetailTS: {
                                            ...isChanged?.bankDetailTS,
                                            showQRorUPI: e?.target?.checked,
                                          },
                                        });
                                      } else {
                                        setIsChanged({
                                          ...isChanged,
                                          bankDetailTS: {
                                            ...isChanged?.bankDetailTS,
                                            showQRorUPI: false,
                                          },
                                        });
                                      }
                                      // setShowBankDetail(e?.target?.checked);
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Font"
                                  labelCol={{ span: 11 }}
                                  name={["bankDetailTS", "font", "fontFamily"]}
                                  className="inputBoxMb8"
                                >
                                  <Select
                                    style={{ width: "147px" }}
                                    options={fontNameOptions}
                                    onChange={(value) => {
                                      form.setFieldsValue({
                                        bankDetailTS: {
                                          ...isChanged?.bankDetailTS,
                                          font: {
                                            ...isChanged?.bankDetailTS?.font,
                                            fontFamily: value,
                                          },
                                        },
                                      });

                                      setIsChanged((prev) => ({
                                        ...prev,
                                        bankDetailTS: {
                                          ...prev?.bankDetailTS,
                                          font: {
                                            ...prev?.bankDetailTS?.font,
                                            fontFamily: value,
                                          },
                                        },
                                      }));
                                    }}
                                  />
                                </Form.Item>
                                <Form.Item
                                  label="Font size"
                                  labelCol={{ span: 11 }}
                                  name={["bankDetailTS", "font", "fontSize"]}
                                  className="inputBoxMb8"
                                >
                                  <Select
                                    style={{ width: "147px" }}
                                    options={fontSizeOptions}
                                    onChange={(value) => {
                                      form.setFieldsValue({
                                        bankDetailTS: {
                                          ...isChanged?.bankDetailTS,
                                          font: {
                                            ...isChanged?.bankDetailTS?.font,
                                            fontSize: value,
                                          },
                                        },
                                      });

                                      setIsChanged((prev) => ({
                                        ...prev,
                                        bankDetailTS: {
                                          ...prev?.bankDetailTS,
                                          font: {
                                            ...prev?.bankDetailTS?.font,
                                            fontSize: value,
                                          },
                                        },
                                      }));
                                    }}
                                  />
                                </Form.Item>
                              </>
                            )}
                          </>
                        ),
                      },
                      {
                        label: "Balance Details",
                        key: "9",
                        children: (
                          <>
                            <Form.Item
                              label="Show Balance"
                              name={["balanceDetailTS", "showBalanceStatus"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                              labelCol={{ span: 20 }}
                              labelAlign="left"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.balanceDetailTS?.showBalanceStatus
                                }
                                onChange={(e: any) => {
                                  if (e.target.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      balanceDetailTS: {
                                        ...isChanged?.balanceDetailTS,
                                        showBalanceStatus: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      balanceDetailTS: {
                                        ...isChanged?.balanceDetailTS,
                                        showBalanceStatus: false,
                                      },
                                    });
                                  }
                                  console.log(
                                    isChanged?.balanceDetailTS
                                      ?.showBalanceStatus,
                                    "ok"
                                  );
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font"
                              name={["balanceDetailTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                              labelCol={{ span: 20 }}
                              labelAlign="left"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    balanceDetailTS: {
                                      ...isChanged?.balanceDetailTS,
                                      font: {
                                        ...isChanged?.balanceDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    balanceDetailTS: {
                                      ...prev?.balanceDetailTS,
                                      font: {
                                        ...prev?.balanceDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["balanceDetailTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                              labelCol={{ span: 20 }}
                              labelAlign="left"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    balanceDetailTS: {
                                      ...isChanged?.balanceDetailTS,
                                      font: {
                                        ...isChanged?.balanceDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    balanceDetailTS: {
                                      ...prev?.balanceDetailTS,
                                      font: {
                                        ...prev?.balanceDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>{" "}
                          </>
                        ),
                      },
                      {
                        label: "Dispatch Details",
                        key: "10",
                        children: (
                          <>
                            <Form.Item
                              label="Show Detail"
                              name={["dispatchDetailTS", "showDispatchDetail"]}
                              className="inputBoxMb8"
                              valuePropName="checked"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.dispatchDetailTS
                                    ?.showDispatchDetail
                                }
                                onChange={(e: any) => {
                                  if (e.target.checked) {
                                    setIsChanged({
                                      ...isChanged,
                                      dispatchDetailTS: {
                                        ...isChanged?.dispatchDetailTS,
                                        showDispatchDetail: e?.target?.checked,
                                      },
                                    });
                                  } else {
                                    setIsChanged({
                                      ...isChanged,
                                      dispatchDetailTS: {
                                        ...isChanged?.dispatchDetailTS,
                                        showDispatchDetail: false,
                                      },
                                    });
                                  }
                                  console.log(
                                    isChanged?.dispatchDetailTS
                                      ?.showDispatchDetail,
                                    "ok"
                                  );
                                }}
                              />
                            </Form.Item>
                            {/* {formBaiscLayout()} */}
                            <Form.Item
                              label="Font"
                              name={["dispatchDetailTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    dispatchDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      font: {
                                        ...isChanged?.dispatchDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    dispatchDetailTS: {
                                      ...prev?.dispatchDetailTS,
                                      font: {
                                        ...prev?.dispatchDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["dispatchDetailTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    dispatchDetailTS: {
                                      ...isChanged?.dispatchDetailTS,
                                      font: {
                                        ...isChanged?.dispatchDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    dispatchDetailTS: {
                                      ...prev?.dispatchDetailTS,
                                      font: {
                                        ...prev?.dispatchDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Signature Details",
                        key: "11",
                        children: (
                          <>
                            <Form.Item
                              label="Heading Font"
                              name={[
                                "signDetailTS",
                                "headingFont",
                                "fontFamily",
                              ]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    signDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      headingFont: {
                                        ...isChanged?.signDetailTS?.headingFont,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    signDetailTS: {
                                      ...prev?.signDetailTS,
                                      headingFont: {
                                        ...prev?.signDetailTS?.headingFont,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Heading size"
                              name={["signDetailTS", "headingFont", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={voucherTitlefontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    signDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      headingFont: {
                                        ...isChanged?.signDetailTS?.headingFont,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    signDetailTS: {
                                      ...prev?.signDetailTS,
                                      headingFont: {
                                        ...prev?.signDetailTS?.headingFont,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>

                            <Form.Item
                              label="Font"
                              name={["signDetailTS", "font", "fontFamily"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    signDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      font: {
                                        ...isChanged?.signDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    signDetailTS: {
                                      ...prev?.signDetailTS,
                                      font: {
                                        ...prev?.signDetailTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["signDetailTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    signDetailTS: {
                                      ...isChanged?.signDetailTS,
                                      font: {
                                        ...isChanged?.signDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    signDetailTS: {
                                      ...prev?.signDetailTS,
                                      font: {
                                        ...prev?.signDetailTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },

                      {
                        label: "Terms & Conditions",
                        key: "12",
                        children: (
                          <>
                            <Form.Item
                              label="Position"
                              name={["termsndConditionTS", "tnCPosition"]}
                              className="inputBoxMb8"
                              labelCol={{ span: "15" }}
                              labelAlign="left"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={[
                                  {
                                    value: TnC_Position.TopRight,
                                    label: "Top Right",
                                  },
                                  {
                                    value: TnC_Position.BottomLeft,
                                    label: "Bottom Left",
                                  },
                                  {
                                    value: TnC_Position.NextPage,
                                    label: "Next Page",
                                  },
                                ]}
                                onChange={(val: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    termsndConditionTS: {
                                      ...isChanged?.termsndConditionTS,
                                      tnCPosition: val,
                                    },
                                  });
                                }}
                              ></Select>
                            </Form.Item>

                            <Form.Item
                              label="Font"
                              name={[
                                "termsndConditionTS",
                                "font",
                                "fontFamily",
                              ]}
                              className="inputBoxMb8"
                              labelCol={{ span: "15" }}
                              labelAlign="left"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontNameOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    termsndConditionTS: {
                                      ...isChanged?.termsndConditionTS,
                                      font: {
                                        ...isChanged?.termsndConditionTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    termsndConditionTS: {
                                      ...prev?.termsndConditionTS,
                                      font: {
                                        ...prev?.termsndConditionTS?.font,
                                        fontFamily: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                            <Form.Item
                              label="Font size"
                              name={["termsndConditionTS", "font", "fontSize"]}
                              className="inputBoxMb8"
                              labelCol={{ span: "15" }}
                              labelAlign="left"
                            >
                              <Select
                                style={{ width: "147px" }}
                                options={fontSizeOptions}
                                onChange={(value) => {
                                  form.setFieldsValue({
                                    termsndConditionTS: {
                                      ...isChanged?.companyTS,
                                      font: {
                                        ...isChanged?.termsndConditionTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  });

                                  setIsChanged((prev) => ({
                                    ...prev,
                                    termsndConditionTS: {
                                      ...prev?.termsndConditionTS,
                                      font: {
                                        ...prev?.termsndConditionTS?.font,
                                        fontSize: value,
                                      },
                                    },
                                  }));
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                      {
                        label: "Header continuation",
                        key: "13",
                        children: (
                          <>
                            <Form.Item
                              label="Show on next page"
                              name="showHeaderContinuation"
                              className="inputBoxMb8"
                              valuePropName="checked"
                              labelCol={{ span: "20" }}
                              labelAlign="left"
                            >
                              <Checkbox
                                defaultChecked={
                                  isChanged?.showHeaderContinuation
                                }
                                onChange={(e: any) => {
                                  setIsChanged({
                                    ...isChanged,
                                    showHeaderContinuation: e?.target?.checked,
                                  });
                                }}
                              />
                            </Form.Item>
                          </>
                        ),
                      },
                    ]}
                  />
                </Form>
              </Row>
              <Row
                style={{
                  position: "absolute",
                  bottom: "30px",
                  right: "30px",
                }}
                justify={"end"}
              >
                <Col className="ps-14">
                  <Button
                    type="default"
                    size="middle"
                    onClick={() => {
                      navigate(
                        `/billing/clients/${currentClient?.id}/settings/templates`
                      );
                    }}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col className="ps-14">
                  <Button
                    loading={saveButtonLoading}
                    type="primary"
                    size="middle"
                    onClick={() => onsubmit()}
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </Card>
          </Col>

          {/* Templete 1 GST Format */}
          <Col
            lg={14}
            md={24}
            style={{
              height: "90vh",
              width: "100%",
              overflowY: "auto",
            }}
          >
            <Card
              style={{
                margin: "0px 10px",
                width: "210mm",
                height: "297mm",
              }}
              className="template"
            >
              <Row
                className="customTemplateBody"
                style={{
                  paddingTop: `${isChanged?.generalTS?.topMargin}mm`,
                  paddingBottom: `${isChanged?.generalTS?.bottomMargin}mm`,
                  paddingLeft: `${isChanged?.generalTS?.leftMargin}mm`,
                  paddingRight: `${isChanged?.generalTS?.rightMargin}mm`,
                  fontSize: isChanged?.generalTS?.font?.fontSize * 1.333,
                  fontFamily: isChanged?.generalTS?.font?.fontFamily,
                }}
              >
                <Col span={24}>
                  {/* Company Logo, Business Address and Voucher Title */}
                  <Row
                    justify={"space-between"}
                    style={{
                      padding: "5px 0px",
                      width: "100%",
                    }}
                  >
                    <Col span={16}>
                      <Row
                        style={{
                          flexDirection:
                            isChanged?.companyTS?.logoAlign === 0
                              ? "row"
                              : "column",
                        }}
                      >
                        {/* Company Logo */}
                        <Col>
                          <span>
                            <img
                              src={currentClient?.logo?.filePath}
                              alt="Logo"
                              style={{
                                height: "65%",
                                display: isChanged?.companyTS?.showLogo
                                  ? ""
                                  : "none",
                              }}
                            />
                          </span>
                        </Col>
                        {/* Company Name and Address */}
                        <Col
                          style={{
                            justifyContent: "space-between",
                            display: "flex",
                            padding: "5px",
                            fontFamily: isChanged?.companyTS?.font?.fontFamily!,
                            fontSize:
                              isChanged?.companyTS?.font?.fontSize * 1.333,
                          }}
                        >
                          <div>
                            <h3
                              style={{
                                fontSize:
                                  isChanged?.companyTS?.companyNameFont
                                    ?.fontSize * 1.333,
                                fontFamily:
                                  isChanged?.companyTS?.companyNameFont
                                    ?.fontFamily,
                                marginBottom: "5px",
                              }}
                            >
                              {currentClient?.businessName}
                            </h3>
                            <p
                              style={{
                                margin: "0px",
                                display: isChanged?.companyTS
                                  ?.showCompanyAddress
                                  ? ""
                                  : "none",
                              }}
                            >
                              Basni Industrial Area, Jodhpur
                            </p>
                            <p
                              style={{
                                margin: "0px",
                              }}
                            >
                              <strong style={{}}> State</strong>: 08-Rajasthan,
                              <strong
                                style={{
                                  display: isChanged?.companyTS?.showGSTIN
                                    ? ""
                                    : "none",
                                }}
                              >
                                GSTIN
                              </strong>
                              <span
                                style={{
                                  display: isChanged?.companyTS?.showGSTIN
                                    ? ""
                                    : "none",
                                }}
                              >
                                : 08ABCCA4785G1ZZ,
                              </span>
                              <span
                                style={{
                                  display: isChanged?.companyTS?.showPan
                                    ? ""
                                    : "none",
                                }}
                              >
                                <strong>PAN</strong>: ABCCA4785G
                              </span>
                            </p>
                            <p style={{ margin: "0px" }}>
                              <span
                                style={{
                                  display: isChanged?.companyTS?.showEmail
                                    ? ""
                                    : "none",
                                }}
                              >
                                <strong>Email:</strong> test@gmail.com,
                              </span>
                              <span
                                style={{
                                  display: isChanged?.companyTS?.showPhone
                                    ? ""
                                    : "none",
                                }}
                              >
                                <strong>Mobile:</strong> +919898989898
                              </span>
                              ,
                              <span
                                style={{
                                  display: isChanged?.companyTS?.showWebsite
                                    ? ""
                                    : "none",
                                }}
                              >
                                <strong>Website:</strong> www.test.com,
                              </span>
                            </p>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <div
                        style={{
                          textAlign: "right",
                          // fontWeight: "bold",
                          fontFamily: isChanged?.voucherTitleTS?.fontFamily,
                          fontSize: isChanged?.voucherTitleTS?.fontSize * 1.333,
                        }}
                      >
                        <p>TAX INVOICE</p>
                      </div>
                    </Col>
                  </Row>
                  {/* Buyer and Invoice Detail */}
                  <Row
                    style={{
                      fontFamily: isChanged?.buyerShipperTS?.fontFamily,
                      fontSize: isChanged?.buyerShipperTS?.fontSize * 1.333,
                    }}
                  >
                    <Col span={24}>
                      <table className="customTempTable">
                        <tbody>
                          <tr>
                            <td
                              rowSpan={7}
                              style={{ width: "50%", verticalAlign: "top" }}
                            >
                              <p style={{ textDecoration: "underline" }}>
                                Buyer (Bill To)
                              </p>
                              <p>
                                <strong>Party Name</strong>
                              </p>
                              <p>
                                334, Basni II Phase, <br />
                                Jodhpur, Jodhpur, 342001, <br />
                                Rajasthan, India
                              </p>
                              <p
                                style={{
                                  textDecoration: "underline",
                                  marginTop: "10px",
                                }}
                              >
                                Ship To
                              </p>
                              <p>Party Name</p>
                              <p>
                                334, Basni II Phase, <br />
                                Jodhpur, Jodhpur, 342001, <br />
                                Rajasthan, India
                              </p>
                            </td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td>Invoice No.</td>
                            <td>Date</td>
                            <td>Reference</td>
                          </tr>
                          <tr>
                            <td>INV-0003</td>
                            <td>02-04-2024</td>
                            <td>-</td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td>Place of Supply</td>
                            <td colSpan={2}>Mode/Terms of Payment</td>
                          </tr>
                          <tr>
                            <td>08-Rajasthan</td>
                            <td colSpan={2}>-</td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td colSpan={3}>Terms & Conditions</td>
                          </tr>
                          <tr>
                            <td colSpan={3}>
                              Lorem ipsum is a dummy or placeholder text
                              commonly used in graphic design, publishing, and
                              web development to fill empty spaces in a layout
                              that does not yet have content.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {/* Item Table */}
                  <Row style={{ width: "100%", marginTop: "5px" }}>
                    <Col span={24}>
                      <table className="customTempTable">
                        <thead>
                          <tr>
                            <th rowSpan={2}>S.No.</th>
                            <th rowSpan={2}>Item(s)</th>
                            <th rowSpan={2}>Qty</th>
                            <th rowSpan={2}>Unit</th>
                            <th rowSpan={2}>Rate</th>
                            <th rowSpan={2}>Taxable Amount</th>
                            <th colSpan={2}>CGST</th>
                            <th colSpan={2}>SGST</th>
                          </tr>
                          <tr>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th>Rate</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr style={{ height: "200px", verticalAlign: "top" }}>
                            <td style={{ width: "5%" }}>01.</td>
                            <td style={{ width: "30%" }}>Item1</td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              01
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              PCS
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              2.50
                            </td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td style={{ width: "5%" }}></td>
                            <td style={{ width: "30%", textAlign: "right" }}>
                              Total (A)
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              01
                            </td>
                            <td
                              style={{ width: "5%", textAlign: "center" }}
                            ></td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "5%", textAlign: "right" }}>
                              2.50
                            </td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td colSpan={4} style={{ textAlign: "right" }}>
                              Total Invoice Value
                            </td>
                            <td colSpan={6} style={{ textAlign: "right" }}>
                              105.00
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={10}>
                              <strong>Amount (in words) :</strong> One Hundred
                              Five Rupees Only
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {/* Tax Summary */}
                  <Row style={{ width: "100%", marginTop: "5px" }}>
                    <Col span={24}>
                      <table className="customTempTable">
                        <thead>
                          <tr>
                            <th rowSpan={2}>Taxable Value</th>
                            <th colSpan={2}>IGST</th>
                            <th colSpan={2}>CGST</th>
                            <th colSpan={2}>SGST</th>
                            <th rowSpan={2}>Total Tax Amount</th>
                          </tr>
                          <tr>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th>Rate</th>
                            <th>Amount</th>
                            <th>Rate</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{ width: "20%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              0
                            </td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              0.00
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td style={{ width: "5%", textAlign: "center" }}>
                              2.5%
                            </td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td style={{ width: "20%", textAlign: "right" }}>
                              5.00
                            </td>
                          </tr>
                          <tr style={{ fontWeight: "bold" }}>
                            <td style={{ width: "20%", textAlign: "right" }}>
                              100.00
                            </td>
                            <td
                              style={{ width: "5%", textAlign: "center" }}
                            ></td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              0.00
                            </td>
                            <td
                              style={{ width: "5%", textAlign: "center" }}
                            ></td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td
                              style={{ width: "5%", textAlign: "center" }}
                            ></td>
                            <td style={{ width: "15%", textAlign: "right" }}>
                              2.50
                            </td>
                            <td style={{ width: "20%", textAlign: "right" }}>
                              5.00
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {/* Bank Detail */}
                  <Row style={{ width: "100%", marginTop: "5px" }}>
                    <Col span={24}>
                      <table className="customTempTable">
                        <tbody>
                          <tr style={{ fontWeight: "bold" }}>
                            <td colSpan={4}>Bank Detail:</td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>Account Name:</td>
                            <td style={{ width: "50%" }}> </td>
                            <td
                              rowSpan={6}
                              style={{ width: "30%", verticalAlign: "top" }}
                            >
                              QR Code
                            </td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>Account No.:</td>
                            <td style={{ width: "50%" }}> </td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>Branch :</td>
                            <td style={{ width: "50%" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>Bank Name :</td>
                            <td style={{ width: "50%" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>IFS Code :</td>
                            <td style={{ width: "50%" }}></td>
                          </tr>
                          <tr>
                            <td style={{ width: "20%" }}>UPI Id :</td>
                            <td style={{ width: "50%" }}></td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {/* Dispatch Detail */}
                  <Row style={{ width: "100%", marginTop: "5px" }}>
                    <Col span={24}>
                      <table className="customTempTable">
                        <tbody>
                          <tr style={{ fontWeight: "bold" }}>
                            <td colSpan={4}>Dispatch Detail:</td>
                          </tr>
                          <tr>
                            <td style={{ width: "18%" }}>Transporter Name :</td>
                            <td style={{ width: "32%" }}> </td>
                            <td style={{ width: "15%" }}>Vehicle No. :</td>
                            <td style={{ width: "35%" }}> </td>
                          </tr>
                          <tr>
                            <td style={{ width: "18%" }}>Driver Name :</td>
                            <td style={{ width: "32%" }}> </td>
                            <td style={{ width: "15%" }}>Contact No. :</td>
                            <td style={{ width: "35%" }}> </td>
                          </tr>
                          <tr>
                            <td style={{ width: "18%" }}>LR/Bilty No. :</td>
                            <td style={{ width: "32%" }}> </td>
                            <td style={{ width: "15%" }}>LR/Bilty Date :</td>
                            <td style={{ width: "35%" }}> </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                  {/* Signature Block */}
                  <Row style={{ width: "100%", marginTop: "5px" }}>
                    <Col span={24}>
                      <table className="customTempTable">
                        <tbody>
                          <tr style={{ height: "80px" }}>
                            <td style={{ width: "50%", lineHeight: "16px" }}>
                              <p>Disclaimer</p>
                              <p>
                                1. Certified that the particular given above are
                                true and correct and the amount indicated
                                represents the price actually charged and there
                                is no additional consideration flowing, directly
                                or indirectly from the buyer.{" "}
                              </p>
                              <p>2. Subject to Jodhpur Jurisdiction only.</p>
                            </td>
                            <td
                              style={{
                                width: "50%",
                                textAlign: "right",
                              }}
                            >
                              <div
                                style={{
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "55px",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div>
                                  <p>For Company/Firm</p>
                                </div>
                                <div>
                                  <p>(Authorized Signatory)</p>{" "}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default EditInvoiceTemplate;
